import { render, staticRenderFns } from "./PaymentRecordsTableNew.vue?vue&type=template&id=f3e5144a&scoped=true"
import script from "./PaymentRecordsTableNew.vue?vue&type=script&lang=ts"
export * from "./PaymentRecordsTableNew.vue?vue&type=script&lang=ts"
import style0 from "./PaymentRecordsTableNew.vue?vue&type=style&index=0&id=f3e5144a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e5144a",
  null
  
)

export default component.exports